import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';

const JobTemplateStyling = styled.div`
  font-size: 18px;
  line-height: 1.8;
  color: #404040;
  min-height: 640px;

  h2 {
    text-align: center;
  }

  a {
    color: #308184;
    text-decoration: none;
  }

  img {
    max-width: 100%;
  }

  .job-page--header img {
    display: block;
  }

  .fu-btn-job-apply,
  .fu-universal-apply-button {
    display: inline-block;
    padding: 0;
  }

  .fu-btn-job-apply .mdc-button,
  .fu-universal-apply-button .mdc-button, .MuiButtonBase-root {
    background-color: ${({ theme }) => theme.colors.primary};
    color: white;
    white-space: nowrap;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, .1);
    background-clip: padding-box;

    &:hover {
      background-color: ${({ theme }) => theme.colors.primary};
      border: 1px solid rgba(0, 0, 0, .1);
    }

    ${/* eslint-disable-next-line max-len */''}
    /* stylelint-disable-next-line selector-type-no-unknown, no-descending-specificity */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      background-color: rgb(234, 0, 81);
    }
  }

  .mdl-grid {
    /* from the original mdl styles */
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    display: flex;
    /* from the original mdl styles */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: horizontal;
    /* from the original mdl styles */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-direction: normal;
    flex-flow: row wrap;
    margin: 0 auto;
    /* from the original mdl styles */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-align: stretch;
    align-items: stretch
  }

  .mdl-grid.mdl-grid--no-spacing {
    padding: 0
  }

  .mdl-cell {
    box-sizing: border-box
  }

  .mdl-cell--top {
    align-self: flex-start
  }

  .mdl-cell--middle {
    align-self: center
  }

  .mdl-cell--bottom {
    align-self: flex-end
  }

  .mdl-cell--stretch {
    align-self: stretch
  }

  .mdl-grid.mdl-grid--no-spacing>
    .mdl-cell {
    margin: 0
  }

  @media (max-width: ${breakpoints.xssm}px) {
    .mdl-grid {
      padding: 8px
    }

    .mdl-cell {
      margin: 8px;
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell {
      width: 100%
    }

    .mdl-cell--hide-phone {
      /* from the original mdl styles */
      /* stylelint-disable-next-line declaration-no-important */
      display: none !important
    }

    .mdl-cell--1-col,
    .mdl-cell--1-col-phone.mdl-cell--1-col-phone {
      width: calc(25% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--1-col,
    .mdl-grid--no-spacing>
      .mdl-cell--1-col-phone.mdl-cell--1-col-phone {
      width: 25%
    }

    .mdl-cell--2-col,
    .mdl-cell--2-col-phone.mdl-cell--2-col-phone {
      width: calc(50% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--2-col,
    .mdl-grid--no-spacing>
      .mdl-cell--2-col-phone.mdl-cell--2-col-phone {
      width: 50%
    }

    .mdl-cell--3-col,
    .mdl-cell--3-col-phone.mdl-cell--3-col-phone {
      width: calc(75% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--3-col,
    .mdl-grid--no-spacing>
      .mdl-cell--3-col-phone.mdl-cell--3-col-phone {
      width: 75%
    }

    .mdl-cell--4-col,
    .mdl-cell--4-col-phone.mdl-cell--4-col-phone {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--4-col,
    .mdl-grid--no-spacing>
      .mdl-cell--4-col-phone.mdl-cell--4-col-phone {
      width: 100%
    }

    .mdl-cell--5-col,
    .mdl-cell--5-col-phone.mdl-cell--5-col-phone {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--5-col,
    .mdl-grid--no-spacing>
      .mdl-cell--5-col-phone.mdl-cell--5-col-phone {
      width: 100%
    }

    .mdl-cell--6-col,
    .mdl-cell--6-col-phone.mdl-cell--6-col-phone {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--6-col,
    .mdl-grid--no-spacing>
      .mdl-cell--6-col-phone.mdl-cell--6-col-phone {
      width: 100%
    }

    .mdl-cell--7-col,
    .mdl-cell--7-col-phone.mdl-cell--7-col-phone {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--7-col,
    .mdl-grid--no-spacing>
      .mdl-cell--7-col-phone.mdl-cell--7-col-phone {
      width: 100%
    }

    .mdl-cell--8-col,
    .mdl-cell--8-col-phone.mdl-cell--8-col-phone {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--8-col,
    .mdl-grid--no-spacing>
      .mdl-cell--8-col-phone.mdl-cell--8-col-phone {
      width: 100%
    }

    .mdl-cell--9-col,
    .mdl-cell--9-col-phone.mdl-cell--9-col-phone {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--9-col,
    .mdl-grid--no-spacing>
      .mdl-cell--9-col-phone.mdl-cell--9-col-phone {
      width: 100%
    }

    .mdl-cell--10-col,
    .mdl-cell--10-col-phone.mdl-cell--10-col-phone {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--10-col,
    .mdl-grid--no-spacing>
      .mdl-cell--10-col-phone.mdl-cell--10-col-phone {
      width: 100%
    }

    .mdl-cell--11-col,
    .mdl-cell--11-col-phone.mdl-cell--11-col-phone {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--11-col,
    .mdl-grid--no-spacing>
      .mdl-cell--11-col-phone.mdl-cell--11-col-phone {
      width: 100%
    }

    .mdl-cell--12-col,
    .mdl-cell--12-col-phone.mdl-cell--12-col-phone {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--12-col,
    .mdl-grid--no-spacing>
      .mdl-cell--12-col-phone.mdl-cell--12-col-phone {
      width: 100%
    }

    .mdl-cell--1-offset,
    .mdl-cell--1-offset-phone.mdl-cell--1-offset-phone {
      margin-left: calc(25% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--1-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--1-offset-phone.mdl-cell--1-offset-phone {
      margin-left: 25%
    }

    .mdl-cell--2-offset,
    .mdl-cell--2-offset-phone.mdl-cell--2-offset-phone {
      margin-left: calc(50% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--2-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--2-offset-phone.mdl-cell--2-offset-phone {
      margin-left: 50%
    }

    .mdl-cell--3-offset,
    .mdl-cell--3-offset-phone.mdl-cell--3-offset-phone {
      margin-left: calc(75% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--3-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--3-offset-phone.mdl-cell--3-offset-phone {
      margin-left: 75%
    }
  }

  @media (min-width: ${
  breakpoints.xssm
}px) and (max-width: ${
  breakpoints.md
}px) {
    .mdl-grid {
      padding: 8px
    }

    .mdl-cell {
      margin: 8px;
      width: calc(50% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell {
      width: 50%
    }

    .mdl-cell--hide-tablet {
      /* from the original mdl styles */
      /* stylelint-disable-next-line declaration-no-important */
      display: none !important
    }

    .mdl-cell--1-col,
    .mdl-cell--1-col-tablet.mdl-cell--1-col-tablet {
      width: calc(12.5% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--1-col,
    .mdl-grid--no-spacing>
      .mdl-cell--1-col-tablet.mdl-cell--1-col-tablet {
      width: 12.5%
    }

    .mdl-cell--2-col,
    .mdl-cell--2-col-tablet.mdl-cell--2-col-tablet {
      width: calc(25% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--2-col,
    .mdl-grid--no-spacing>
      .mdl-cell--2-col-tablet.mdl-cell--2-col-tablet {
      width: 25%
    }

    .mdl-cell--3-col,
    .mdl-cell--3-col-tablet.mdl-cell--3-col-tablet {
      width: calc(37.5% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--3-col,
    .mdl-grid--no-spacing>
      .mdl-cell--3-col-tablet.mdl-cell--3-col-tablet {
      width: 37.5%
    }

    .mdl-cell--4-col,
    .mdl-cell--4-col-tablet.mdl-cell--4-col-tablet {
      width: calc(50% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--4-col,
    .mdl-grid--no-spacing>
      .mdl-cell--4-col-tablet.mdl-cell--4-col-tablet {
      width: 50%
    }

    .mdl-cell--5-col,
    .mdl-cell--5-col-tablet.mdl-cell--5-col-tablet {
      width: calc(62.5% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--5-col,
    .mdl-grid--no-spacing>
      .mdl-cell--5-col-tablet.mdl-cell--5-col-tablet {
      width: 62.5%
    }

    .mdl-cell--6-col,
    .mdl-cell--6-col-tablet.mdl-cell--6-col-tablet {
      width: calc(75% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--6-col,
    .mdl-grid--no-spacing>
      .mdl-cell--6-col-tablet.mdl-cell--6-col-tablet {
      width: 75%
    }

    .mdl-cell--7-col,
    .mdl-cell--7-col-tablet.mdl-cell--7-col-tablet {
      width: calc(87.5% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--7-col,
    .mdl-grid--no-spacing>
      .mdl-cell--7-col-tablet.mdl-cell--7-col-tablet {
      width: 87.5%
    }

    .mdl-cell--8-col,
    .mdl-cell--8-col-tablet.mdl-cell--8-col-tablet {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--8-col,
    .mdl-grid--no-spacing>
      .mdl-cell--8-col-tablet.mdl-cell--8-col-tablet {
      width: 100%
    }

    .mdl-cell--9-col,
    .mdl-cell--9-col-tablet.mdl-cell--9-col-tablet {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--9-col,
    .mdl-grid--no-spacing>
      .mdl-cell--9-col-tablet.mdl-cell--9-col-tablet {
      width: 100%
    }

    .mdl-cell--10-col,
    .mdl-cell--10-col-tablet.mdl-cell--10-col-tablet {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--10-col,
    .mdl-grid--no-spacing>
      .mdl-cell--10-col-tablet.mdl-cell--10-col-tablet {
      width: 100%
    }

    .mdl-cell--11-col,
    .mdl-cell--11-col-tablet.mdl-cell--11-col-tablet {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--11-col,
    .mdl-grid--no-spacing>
      .mdl-cell--11-col-tablet.mdl-cell--11-col-tablet {
      width: 100%
    }

    .mdl-cell--12-col,
    .mdl-cell--12-col-tablet.mdl-cell--12-col-tablet {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--12-col,
    .mdl-grid--no-spacing>
      .mdl-cell--12-col-tablet.mdl-cell--12-col-tablet {
      width: 100%
    }

    .mdl-cell--1-offset,
    .mdl-cell--1-offset-tablet.mdl-cell--1-offset-tablet {
      margin-left: calc(12.5% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--1-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--1-offset-tablet.mdl-cell--1-offset-tablet {
      margin-left: 12.5%
    }

    .mdl-cell--2-offset,
    .mdl-cell--2-offset-tablet.mdl-cell--2-offset-tablet {
      margin-left: calc(25% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--2-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--2-offset-tablet.mdl-cell--2-offset-tablet {
      margin-left: 25%
    }

    .mdl-cell--3-offset,
    .mdl-cell--3-offset-tablet.mdl-cell--3-offset-tablet {
      margin-left: calc(37.5% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--3-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--3-offset-tablet.mdl-cell--3-offset-tablet {
      margin-left: 37.5%
    }

    .mdl-cell--4-offset,
    .mdl-cell--4-offset-tablet.mdl-cell--4-offset-tablet {
      margin-left: calc(50% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--4-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--4-offset-tablet.mdl-cell--4-offset-tablet {
      margin-left: 50%
    }

    .mdl-cell--5-offset,
    .mdl-cell--5-offset-tablet.mdl-cell--5-offset-tablet {
      margin-left: calc(62.5% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--5-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--5-offset-tablet.mdl-cell--5-offset-tablet {
      margin-left: 62.5%
    }

    .mdl-cell--6-offset,
    .mdl-cell--6-offset-tablet.mdl-cell--6-offset-tablet {
      margin-left: calc(75% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--6-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--6-offset-tablet.mdl-cell--6-offset-tablet {
      margin-left: 75%
    }

    .mdl-cell--7-offset,
    .mdl-cell--7-offset-tablet.mdl-cell--7-offset-tablet {
      margin-left: calc(87.5% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--7-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--7-offset-tablet.mdl-cell--7-offset-tablet {
      margin-left: 87.5%
    }
  }

  @media (min-width: ${breakpoints.md}px) {
    .mdl-grid {
      padding: 8px
    }

    .mdl-cell {
      margin: 8px;
      width: calc(33.33333% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell {
      width: 33.33333%
    }

    .mdl-cell--hide-desktop {
      /* from the original mdl styles */
      /* stylelint-disable-next-line declaration-no-important */
      display: none !important
    }

    .mdl-cell--1-col,
    .mdl-cell--1-col-desktop.mdl-cell--1-col-desktop {
      width: calc(8.33333% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--1-col,
    .mdl-grid--no-spacing>
      .mdl-cell--1-col-desktop.mdl-cell--1-col-desktop {
      width: 8.33333%
    }

    .mdl-cell--2-col,
    .mdl-cell--2-col-desktop.mdl-cell--2-col-desktop {
      width: calc(16.66667% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--2-col,
    .mdl-grid--no-spacing>
      .mdl-cell--2-col-desktop.mdl-cell--2-col-desktop {
      width: 16.66667%
    }

    .mdl-cell--3-col,
    .mdl-cell--3-col-desktop.mdl-cell--3-col-desktop {
      width: calc(25% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--3-col,
    .mdl-grid--no-spacing>
      .mdl-cell--3-col-desktop.mdl-cell--3-col-desktop {
      width: 25%
    }

    .mdl-cell--4-col,
    .mdl-cell--4-col-desktop.mdl-cell--4-col-desktop {
      width: calc(33.33333% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--4-col,
    .mdl-grid--no-spacing>
      .mdl-cell--4-col-desktop.mdl-cell--4-col-desktop {
      width: 33.33333%
    }

    .mdl-cell--5-col,
    .mdl-cell--5-col-desktop.mdl-cell--5-col-desktop {
      width: calc(41.66667% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--5-col,
    .mdl-grid--no-spacing>
      .mdl-cell--5-col-desktop.mdl-cell--5-col-desktop {
      width: 41.66667%
    }

    .mdl-cell--6-col,
    .mdl-cell--6-col-desktop.mdl-cell--6-col-desktop {
      width: calc(50% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--6-col,
    .mdl-grid--no-spacing>
      .mdl-cell--6-col-desktop.mdl-cell--6-col-desktop {
      width: 50%
    }

    .mdl-cell--7-col,
    .mdl-cell--7-col-desktop.mdl-cell--7-col-desktop {
      width: calc(58.33333% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--7-col,
    .mdl-grid--no-spacing>
      .mdl-cell--7-col-desktop.mdl-cell--7-col-desktop {
      width: 58.33333%
    }

    .mdl-cell--8-col,
    .mdl-cell--8-col-desktop.mdl-cell--8-col-desktop {
      width: calc(66.66667% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--8-col,
    .mdl-grid--no-spacing>
      .mdl-cell--8-col-desktop.mdl-cell--8-col-desktop {
      width: 66.66667%
    }

    .mdl-cell--9-col,
    .mdl-cell--9-col-desktop.mdl-cell--9-col-desktop {
      width: calc(75% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--9-col,
    .mdl-grid--no-spacing>
      .mdl-cell--9-col-desktop.mdl-cell--9-col-desktop {
      width: 75%
    }

    .mdl-cell--10-col,
    .mdl-cell--10-col-desktop.mdl-cell--10-col-desktop {
      width: calc(83.33333% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--10-col,
    .mdl-grid--no-spacing>
      .mdl-cell--10-col-desktop.mdl-cell--10-col-desktop {
      width: 83.33333%
    }

    .mdl-cell--11-col,
    .mdl-cell--11-col-desktop.mdl-cell--11-col-desktop {
      width: calc(91.66667% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--11-col,
    .mdl-grid--no-spacing>
      .mdl-cell--11-col-desktop.mdl-cell--11-col-desktop {
      width: 91.66667%
    }

    .mdl-cell--12-col,
    .mdl-cell--12-col-desktop.mdl-cell--12-col-desktop {
      width: calc(100% - 16px)
    }

    .mdl-grid--no-spacing>
      .mdl-cell--12-col,
    .mdl-grid--no-spacing>
      .mdl-cell--12-col-desktop.mdl-cell--12-col-desktop {
      width: 100%
    }

    .mdl-cell--1-offset,
    .mdl-cell--1-offset-desktop.mdl-cell--1-offset-desktop {
      margin-left: calc(8.33333% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--1-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--1-offset-desktop.mdl-cell--1-offset-desktop {
      margin-left: 8.33333%
    }

    .mdl-cell--2-offset,
    .mdl-cell--2-offset-desktop.mdl-cell--2-offset-desktop {
      margin-left: calc(16.66667% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--2-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--2-offset-desktop.mdl-cell--2-offset-desktop {
      margin-left: 16.66667%
    }

    .mdl-cell--3-offset,
    .mdl-cell--3-offset-desktop.mdl-cell--3-offset-desktop {
      margin-left: calc(25% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--3-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--3-offset-desktop.mdl-cell--3-offset-desktop {
      margin-left: 25%
    }

    .mdl-cell--4-offset,
    .mdl-cell--4-offset-desktop.mdl-cell--4-offset-desktop {
      margin-left: calc(33.33333% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--4-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--4-offset-desktop.mdl-cell--4-offset-desktop {
      margin-left: 33.33333%
    }

    .mdl-cell--5-offset,
    .mdl-cell--5-offset-desktop.mdl-cell--5-offset-desktop {
      margin-left: calc(41.66667% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--5-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--5-offset-desktop.mdl-cell--5-offset-desktop {
      margin-left: 41.66667%
    }

    .mdl-cell--6-offset,
    .mdl-cell--6-offset-desktop.mdl-cell--6-offset-desktop {
      margin-left: calc(50% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--6-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--6-offset-desktop.mdl-cell--6-offset-desktop {
      margin-left: 50%
    }

    .mdl-cell--7-offset,
    .mdl-cell--7-offset-desktop.mdl-cell--7-offset-desktop {
      margin-left: calc(58.33333% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--7-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--7-offset-desktop.mdl-cell--7-offset-desktop {
      margin-left: 58.33333%
    }

    .mdl-cell--8-offset,
    .mdl-cell--8-offset-desktop.mdl-cell--8-offset-desktop {
      margin-left: calc(66.66667% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--8-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--8-offset-desktop.mdl-cell--8-offset-desktop {
      margin-left: 66.66667%
    }

    .mdl-cell--9-offset,
    .mdl-cell--9-offset-desktop.mdl-cell--9-offset-desktop {
      margin-left: calc(75% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--9-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--9-offset-desktop.mdl-cell--9-offset-desktop {
      margin-left: 75%
    }

    .mdl-cell--10-offset,
    .mdl-cell--10-offset-desktop.mdl-cell--10-offset-desktop {
      margin-left: calc(83.33333% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--10-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--10-offset-desktop.mdl-cell--10-offset-desktop {
      margin-left: 83.33333%
    }

    .mdl-cell--11-offset,
    .mdl-cell--11-offset-desktop.mdl-cell--11-offset-desktop {
      margin-left: calc(91.66667% + 8px)
    }

    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--11-offset,
    .mdl-grid.mdl-grid--no-spacing>
      .mdl-cell--11-offset-desktop.mdl-cell--11-offset-desktop {
      margin-left: 91.66667%
    }
  }
`;

export default JobTemplateStyling;
